import React, { FC } from 'react';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import useStyles from './styles';
import { SectionHeadingProps } from './types';

const SectionHeading: FC<SectionHeadingProps> = props => {
  const { leftAligned = false, title } = props;

  const classes = useStyles();

  return (
    <Typography className={clsx(classes.heading, { [classes.leftAligned]: leftAligned })} component="h2" variant="h2">
      {title}
    </Typography>
  );
};

export default SectionHeading;
